import { EXPORT_JOBS_FILTERS_FAILURE, EXPORT_JOBS_FILTERS_REQUEST, EXPORT_JOBS_FILTERS_SUCCESS, ExportJobsFiltersActionTypes, ExportJobsFiltersState } from './types';

const defaultState: ExportJobsFiltersState = {
  isLoading: false,
  errorMessage: '',
};

export default function exportJobsFilters(state = defaultState, action: ExportJobsFiltersActionTypes): ExportJobsFiltersState {
  switch (action.type) {
    case EXPORT_JOBS_FILTERS_REQUEST:
      return { ...state, isLoading: true };
    case EXPORT_JOBS_FILTERS_SUCCESS:
      return { ...state, contents: action.contents, isLoading: false, errorMessage: '' };
    case EXPORT_JOBS_FILTERS_FAILURE:
      return { ...state, isLoading: false, errorMessage: '' };
    default:
      return state;
  }
}
